import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from "@material-ui/core/styles";
import {SizeMe} from "react-sizeme";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import List from "@material-ui/core/List";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CalendarStrings from "../constants/calendarStrings";
import Moment from "react-moment";

const useStyles = makeStyles(theme => ({
    dialog: {
        '& .MuiDialog-paper': {
            width: 600,
        },
    },
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 0 auto',
    },
    cover: {
        width: 151,
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
    card: {
        padding: theme.spacing(1),
        '& .MuiCardContent-root:last-child': {
            paddingBottom: theme.spacing(1)
        },
        '& .MuiCardContent-root': {
            padding: theme.spacing(1)
        }
    }
}));

const MergeDialog = props => {
    const classes = useStyles();
    const [choices, setChoices] = useState();
    const [mainChoice, setMainChoice] = useState('');

    useEffect(() => {
        if (props.choices && props.choices.length > 0) {
            let tmpChoices = [...props.choices];
            tmpChoices.sort((a, b) => {
                const nameLen = b.displayName.length - a.displayName.length;
                if (nameLen !== 0) return nameLen;
                return a.updatedAt - b.updatedAt;
            });
            setMainChoice(props.mergeType === 'contact' ? tmpChoices[0].contactId : tmpChoices[0].accountId);
            setChoices(tmpChoices);
        }
    }, [props.choices, props.mergeType]);

    const handleChange = (e) => {
        setMainChoice(e.target.value);
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.handleNo}
            className={classes.dialog}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
            <DialogContent>
                <SizeMe>
                    {({size}) => {
                        let height = size.height;
                        if (!height) height = window.innerHeight;

                        return (
                            <List style={{maxHeight: '350px', overflow: 'auto', width: '100%', paddingBottom: '15px'}}>
                                {choices && <RadioGroup aria-label="choices" name="choices" value={mainChoice}
                                                        onChange={handleChange}>
                                    {choices.map((choice) => {
                                        return (
                                            <Card variant="outlined" className={classes.card} key={props.mergeType === 'contact' ? choice.contactId : choice.accountId}>
                                                <CardContent>
                                                    <Grid container>
                                                        <Grid item xs={2} className={classes.leftBox}>
                                                            <Radio value={props.mergeType === 'contact' ? choice.contactId : choice.accountId}/>
                                                        </Grid>
                                                        <Grid item xs={10} className={classes.rightBox}>
                                                            <Typography color="textPrimary">
                                                                {choice.displayName}
                                                            </Typography>
                                                            <Typography color="textSecondary">
                                                                Updated: <Moment
                                                                calendar={CalendarStrings}>{choice.updatedAt}</Moment>
                                                            </Typography>
                                                            {choice.contactLinkedinId && <Typography color="textSecondary">
                                                                LinkedIn: {choice.contactLinkedinId}
                                                            </Typography>}
                                                            {choice.accountLinkedinId && <Typography color="textSecondary">
                                                                LinkedIn: {choice.accountLinkedinId}
                                                            </Typography>}
                                                            {choice.tags && choice.tags.length > 0 &&
                                                            <Typography variant="body2" component="p"
                                                                        color="textSecondary">
                                                                Tags: {choice.tags.map(tag => tag.tag).join(', ')}
                                                            </Typography>}
                                                        </Grid>
                                                    </Grid>

                                                </CardContent>
                                            </Card>
                                        )
                                    })}
                                </RadioGroup>}
                            </List>
                        )
                    }}
                </SizeMe>
            </DialogContent>
            <DialogActions>
                <Button
                    id={"merge-records-cancel"}
                    variant="contained"
                    onClick={() => {
                        props.handleCancel();
                    }}
                    color="secondary"
                >
                    Cancel
                </Button>
                <Button
                    id={"merge-records-export"}
                    variant="contained"
                    onClick={() => {
                        props.handleMerge(mainChoice);
                    }}
                    color="primary"
                    autoFocus
                >
                    Merge
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MergeDialog
